/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Directive, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UserAuthState } from '../../user-auth/store/user-auth.state';
import { developmentDomains } from '../helpers/development-domains.helper';
import { Organization } from '../models';

/* eslint-disable @typescript-eslint/no-explicit-any */
@Directive({
  selector: '[ogConditionalBetaFeature]',
})
export class ConditionalBetaFeatureDirective implements OnDestroy {
  @Select(UserAuthState.organizationDetails)
  organizationData$: Observable<Organization>;

  private organizationDataSubscription: Subscription;

  constructor(
    private tmpRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
  ) {}

  @Input() set ogConditionalBetaFeature(condition: boolean) {
    if (condition === true) {
      this.processBetaFeature();
    } else {
      this.viewContainer.createEmbeddedView(this.tmpRef);
    }
  }

  private processBetaFeature() {
    this.organizationDataSubscription = this.organizationData$.pipe(filter((data) => !!data)).subscribe((data) => {
      if (developmentDomains(data.domain)) {
        this.viewContainer.createEmbeddedView(this.tmpRef);
      } else {
        this.viewContainer.clear();
      }
    });
  }

  ngOnDestroy() {
    if (this.organizationDataSubscription) {
      this.organizationDataSubscription.unsubscribe();
    }
  }
}
